module.exports = __webpack_public_path__ + "assets/img/num-04-012d2151.png";